import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-110535a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = {
  key: 0,
  class: "badge bg-danger rounded-pill me-3"
}
const _hoisted_4 = {
  key: 1,
  class: "badge bg-info rounded-pill me-3"
}
const _hoisted_5 = {
  key: 2,
  class: "badge bg-info rounded-pill me-3"
}
const _hoisted_6 = {
  key: 3,
  class: "badge bg-warning rounded-pill me-3"
}
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = ["id", "onClick", "checked"]
const _hoisted_14 = ["for"]
const _hoisted_15 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "col-2" }
const _hoisted_18 = { class: "col-4" }
const _hoisted_19 = { class: "row mb-5" }
const _hoisted_20 = { class: "col text-end" }

import BooleanInput from '@/components/inputs/BooleanInput.vue';
    import DateInput from '@/components/inputs/DateInput.vue';
    import DropdownInput from '@/components/inputs/DropdownInput.vue';
    import NumberInput from '@/components/inputs/NumberInput.vue';
    import { API } from '@/helpers/API';
    import { watch, ref, onBeforeMount, computed, onMounted } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TaskDescription',
  props: {
        taskDescriptionId: {
            type: Number,
            required: true
        },
        taskDescriptionDescription: {
            type: String,
            required: true
        },
        rulesList: {
            type: Object,
            required: true
        }
    },
  setup(__props) {

const props = __props;

    const open = ref(false);
    const taskDescriptionRulesUrl = '/engine/task-description-rules/{TaskDescriptionID}'
    const updateTaskDescriptionRulesUrl = 'engine/task-description-rules'
    const taskDescriptionRules = ref<any>([]);
    const taskDescriptionRulesOrg = ref<any>([]);
    const changes = ref(false);
    const rules = ref<any>([]);

    onMounted(async () => {
        rules.value = JSON.parse(JSON.stringify(props.rulesList));
        await getTaskDescriptionRules();
    });



    watch(taskDescriptionRules, () => {
            changes.value = JSON.stringify(taskDescriptionRules.value) !== taskDescriptionRulesOrg.value
        },
        { deep: true }
    );

    

    const getTaskDescriptionRules = () => {
        const requestConfig = {
            url: taskDescriptionRulesUrl.replace('{TaskDescriptionID}', String(props.taskDescriptionId)),
            method: 'get'
        };
        API.request(requestConfig)
        .then((response) => {
            taskDescriptionRules.value = response.data;
            taskDescriptionRules.value.map((rule: any) => {
                rule.Options = JSON.parse(rule.Options);
                rule.EngineRuleID = Number(rule.EngineRuleID);
                return rule;
            });

            taskDescriptionRulesOrg.value = JSON.stringify(taskDescriptionRules.value);
            rules.value.forEach((rule: any) => {
                if (taskDescriptionRules.value.filter((item: any) => Number(item.EngineRuleID) === Number(rule.EngineRuleID)).length > 0) {
                    rule.selected = true;
                }
            });
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const toggleRule = (rule: any) => {
        if (!rule.selected) {
            addRule(rule);
        } else {
            removeRule(rule);
        }

        rule.selected = !rule.selected;
    }

    const addRule = (rule: any) => {
        console.log('addRule', rule);
        const newRule = {
            TaskTypeDescriptionRuleID: null,
            EngineRuleID: rule.EngineRuleID,
            TaskDescriptionID: props.taskDescriptionId,
            Options: {} as any
        };

        for (let option in rule.Options) {
            newRule.Options[option] = null;
        }

        taskDescriptionRules.value.push(newRule);
    }

    const removeRule = (rule: any) => {
        console.log('removeRule', rule);
        const index = taskDescriptionRules.value.findIndex((item: any) => item.EngineRuleID === rule.EngineRuleID);
        taskDescriptionRules.value.splice(index, 1);
    }

    const saveRules = () => {
        console.log(taskDescriptionRules);
        const requestConfig = {
            url: updateTaskDescriptionRulesUrl,
            method: 'POST',
            data: {
                TaskDescriptionID: props.taskDescriptionId,
                rules: taskDescriptionRules.value
            }
        };
        API.request(requestConfig)
        .then((response) => {
            console.log('It has saved!');
            taskDescriptionRulesOrg.value = JSON.stringify(taskDescriptionRules.value);
            changes.value = false;
        })
        .catch((error) => {
            console.log(error);
        });
    }
    

return (_ctx: any,_cache: any) => {
  const _component_b_icon_chevron_compact_down = _resolveComponent("b-icon-chevron-compact-down")!
  const _component_b_icon_chevron_compact_up = _resolveComponent("b-icon-chevron-compact-up")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "row border my-2 rounded pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = !open.value))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h5", null, "#" + _toDisplayString(__props.taskDescriptionId) + " - " + _toDisplayString(__props.taskDescriptionDescription), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        (taskDescriptionRules.value.length < 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Mangler regler!"))
          : _createCommentVNode("", true),
        (taskDescriptionRules.value.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(taskDescriptionRules.value.length) + " Regler", 1))
          : _createCommentVNode("", true),
        (taskDescriptionRules.value.length == 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "1 Regel"))
          : _createCommentVNode("", true),
        (changes.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Ugemte ændringer"))
          : _createCommentVNode("", true),
        (!open.value)
          ? (_openBlock(), _createBlock(_component_b_icon_chevron_compact_down, { key: 4 }))
          : _createCommentVNode("", true),
        (open.value)
          ? (_openBlock(), _createBlock(_component_b_icon_chevron_compact_up, { key: 5 }))
          : _createCommentVNode("", true)
      ])
    ]),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rules.value, (rule) => {
              return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "row" }, rule.EngineRuleID), [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          value: "",
                          id: 'ruleCheckbox_'+rule.EngineRuleID+'_'+__props.taskDescriptionId,
                          onClick: ($event: any) => (toggleRule(rule)),
                          checked: rule.selected
                        }, null, 8, _hoisted_13),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: 'ruleCheckbox_'+rule.EngineRuleID+'_'+__props.taskDescriptionId
                        }, _toDisplayString(rule.Name), 9, _hoisted_14)
                      ])
                    ])
                  ]),
                  (rule.selected)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rule.Options, (option, optionName) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "row ms-3",
                              key: optionName
                            }, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("strong", null, _toDisplayString(option.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                (option.type == 'select')
                                  ? (_openBlock(), _createBlock(DropdownInput, {
                                      key: 0,
                                      showLabel: false,
                                      compact: true,
                                      label: option.name,
                                      modelValue: taskDescriptionRules.value.filter((item) => item.EngineRuleID === rule.EngineRuleID)[0].Options[optionName],
                                      "onUpdate:modelValue": ($event: any) => ((taskDescriptionRules.value.filter((item) => item.EngineRuleID === rule.EngineRuleID)[0].Options[optionName]) = $event),
                                      values: option.options
                                    }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "values"]))
                                  : _createCommentVNode("", true),
                                (option.type == 'boolean')
                                  ? (_openBlock(), _createBlock(BooleanInput, {
                                      key: 1,
                                      showLabel: false,
                                      id: 'rule_'+rule.EngineRuleID+'_'+optionName+'_'+__props.taskDescriptionId,
                                      compact: true,
                                      label: option.name,
                                      modelValue: taskDescriptionRules.value.filter((item) => item.EngineRuleID === rule.EngineRuleID)[0].Options[optionName],
                                      "onUpdate:modelValue": ($event: any) => ((taskDescriptionRules.value.filter((item) => item.EngineRuleID === rule.EngineRuleID)[0].Options[optionName]) = $event),
                                      values: option.options
                                    }, null, 8, ["id", "label", "modelValue", "onUpdate:modelValue", "values"]))
                                  : _createCommentVNode("", true),
                                (option.type == 'int')
                                  ? (_openBlock(), _createBlock(NumberInput, {
                                      key: 2,
                                      showLabel: false,
                                      compact: true,
                                      label: option.name,
                                      modelValue: taskDescriptionRules.value.filter((item) => item.EngineRuleID === rule.EngineRuleID)[0].Options[optionName],
                                      "onUpdate:modelValue": ($event: any) => ((taskDescriptionRules.value.filter((item) => item.EngineRuleID === rule.EngineRuleID)[0].Options[optionName]) = $event),
                                      values: option.options
                                    }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "values"]))
                                  : _createCommentVNode("", true),
                                (option.type == 'date')
                                  ? (_openBlock(), _createBlock(DateInput, {
                                      key: 3,
                                      showLabel: false,
                                      compact: true,
                                      label: option.name,
                                      modelValue: taskDescriptionRules.value.filter((item) => item.EngineRuleID === rule.EngineRuleID)[0].Options[optionName],
                                      "onUpdate:modelValue": ($event: any) => ((taskDescriptionRules.value.filter((item) => item.EngineRuleID === rule.EngineRuleID)[0].Options[optionName]) = $event),
                                      values: option.options
                                    }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "values"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 16))
            }), 256)),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                (changes.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (saveRules()))
                    }, "Gem ændringer"))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})